import React, { useEffect, useState } from "react";
import { Query, Loading } from "../../components";
import TestDescription from "../../components/TestDescription/TestDescription";
import TestStart from "./TestStart";
import { getTest, submitMCQTest } from "../../lib/api";
import TestExpired from '../TestExpired';
import TestMessage from '../TestMessage';
import NetworkSpeed from "network-speed";
import { track } from '@amplitude/analytics-browser';

const testNetworkSpeed = new NetworkSpeed();
const baseUrl = "https://eu.httpbin.org/stream-bytes/50000";
const fileSizeInBytes = 50000;

const Test = ({
  match: {
    params: { tid, qid }
  }
}) => {

  const [networkSpeed, setNetworkSpeed] = useState(0);
  const [firstLoad, setFirstLoad] = useState(true);


  useEffect(() => {
    // console.log("here1");
    async function load() {
      if (firstLoad) {
        setFirstLoad(false);
        const speed = await getNetworkSpeed();
        setNetworkSpeed(speed);
      } 

      const networkTimer = setInterval(async () => {
        const speed = await getNetworkSpeed();
        setNetworkSpeed(speed);
      }, 10000);
      
      return (() => clearInterval(networkTimer));
    }
    // console.log(networkSpeed);
    load();
  }, []);

  // useEffect(() => {
  //   // console.log("here1");
  //   async function load(){
  //     if(firstLoad){
  //       const speed = await getNetworkSpeed();
  //       setFirstLoad(false);
  //       setNetworkSpeed(speed);
  //     }
  //     else 
  //       setTimeout(async () => {
  //         const speed = await getNetworkSpeed();
  //         setNetworkSpeed(speed);
  //       },10000);
  //   }
  //   // console.log(networkSpeed);
  //   load();
  // }, [networkSpeed]);


  const getNetworkSpeed = async () => {
    // console.log("here");
    if (window?.navigator?.onLine) {
      let speed = 0;
      try {
        const speedRes = await testNetworkSpeed.checkDownloadSpeed(
          baseUrl,
          fileSizeInBytes
        );
        speed =
          speedRes?.mbps && speedRes.mbps !== "Infinity"
            ? speedRes.mbps * 8
            : 0;
        // console.log(speedRes);
        return speed;
      } catch (error) {
        return 0;
      }
    }
  };



  useEffect(() => {
    async function trackData() {
      const eventProperties = {
        test_id: tid,
        // previois_screen_name: 'dashboard'
      };
      let result;
      const eventName = "test_module_initiated"
      if (!qid) {
        result = await track(eventName, eventProperties)
          .promise;

        if (result?.code ===200) {
          console.log(`Amplitude Event Fired Successfully. Event : ${eventName}`)
        }
        else {
          console.log(`Amplitude Event Not Fired. Event : ${eventName}`)
        }
        console.log(result)
          
        return result
      }

    }

    try {
      trackData();
    } catch (error) {
      return error;
    }
  }, [tid, qid]);


  return (
    <>
      <Query query={() => getTest(tid)}>
        {({ loading, data }) => {
          if (data) {
            console.log({ data })
            if (data?.status && data?.status == 204) {
              console.log("expired!")
              return <TestMessage tid={tid} callback={'done'} message={data.message} />
            }
            if (data?.status && data?.status == 409) {
              console.log("expired!")
              return <TestMessage tid={tid} callback={'done'} message={data.message} />
            }
            let ct = new Date(data.currentTime);
            // ct.setHours(ct.getHours() + 5);
            // ct.setMinutes(ct.getMinutes() + 30);
            let doe = new Date(data.date_of_expiry)
  
            if (data && ct > doe) {
              console.log("expired!")
              return <TestExpired tid={tid}/>
            }
            if (loading) {
              return <Loading />;
            }
            return !qid ? (
              <TestDescription {...data} {...{ tid }} networkSpeed={networkSpeed} />
            ) : (
              <TestStart {...data} {...{ tid, qid }} submitTest={submitMCQTest} networkSpeed={networkSpeed} />
            );
          }
          else{
             return (
               <TestMessage
                 tid ={tid}
                 message={`Test Details could not be retrived. Contact support if issue persists.`}
               />
             );
          }
        }}
      </Query>
    </>
  );
};

export default Test;
